export default "__VITE_ASSET__BMU0iHq$__"